"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data: function data() {
    return {
      pagination: {
        show: true,
        total: 0,
        pageSize: 10,
        currentPage: 1,
        background: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        'page-sizes': [10, 20, 30, 40, 50, 100]
      }
    };
  },
  computed: {
    getPaginationOptions: function getPaginationOptions() {
      return this.$$deepMerge(this.pagination, this.$attrs.pagination, this.paginationOptions);
    }
  }
};